export const environment = {
  apiUrl: "https://cmq.pontobiometrico.com.br/api/app",
  production: false
};
